export default __webpack_public_path__ + "static/media/buff.eafb1bc0.jpg";